import React from 'react'
import { Link } from "react-router-dom";


const Dental = () => {
    return (
        <>
            <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
                <div className="container">
                    <div className="dz-bnr-inr-entry d-table-cell">
                        <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>डेंटल</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <ul className="">
                                <li className="breadcrumb-item"><Link to="/">होम </Link></li>
                                <li className="breadcrumb-item">डेंटल</li>
                            </ul>
                        </nav>
                        <div className="dz-btn">
                            <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                                <span className="left-icon">
                                    <i className="feather icon-phone-call" />
                                </span>
                                +91 9165155945
                            </a>
                        </div>
                    </div>
                </div>
                <span className="text-vertical">24/7 आपातकालीन सेवा</span>
                <ul className="dz-social">
                    <li>
                        <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
                            <i className="fa-brands fa-facebook-f" />
                        </Link>
                    </li>
                    <li>
                        <a to="https://www.instagram.com" target="_blank">
                            <i className="fa-brands fa-instagram" />
                        </a>
                    </li>

                    <li>
                        <a to="https://twitter.com" target="_blank">
                            <i className="fa-brands fa-x-twitter" />
                        </a>
                    </li>
                    <li>
                        <a to="https://www.youtube.com" target="_blank">
                            <i className="fa-brands fa-youtube" />
                        </a>
                    </li>
                </ul>
            </div>

            <section className="content-inner" style={{ marginTop: "-10px" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/Dental_01.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/Dental_02.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/Dental_03.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/Dental_04.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="content-inner service-single">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 single-inner order-lg-1">
                            <div className="single-media dz-media single-media height-sm radius-lg wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                                <img src="./assets/img/Dental.webp" alt className="object-fit-cover" />
                            </div>
                            <div className="content-item wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <h2>डेंटल</h2>
                                <p>जिन लोगों को लंबे समय से मेडिकल और डेंटल प्रॉब्लम हैं और जिन्हें एक्सपर्ट केयर की ज़रूरत है, उनके लिए हमारा डेंटल केयर डिपार्टमेंट ऑर्थोडॉन्टिक, रेस्टोरेटिव और प्रिवेंटिव थेरेपी देता है। हमारी एक्सपर्ट्स की टीम पेशेंट पर फोकस करती है और उन लोगों की मदद करने के लिए हमेशा तैयार रहती है जो सच में हम पर डिपेंड करते हैं। लेटेस्ट टूल्स और एरिया के सबसे टैलेंटेड डेंटिस्ट के साथ, हम अपनी सर्विसेज़ में कभी कमी नहीं करते। अपने एरिया के एक्सपर्ट, हमारे डेंटल फैकल्टी मेंबर्स पेशेंट की ज़रूरतों के आधार पर बहुत अच्छी केयर और कस्टमाइज़्ड ट्रीटमेंट प्रोग्राम देने के लिए जाने जाते हैं।</p>
                            </div>
                            <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                                <h3>हम इन स्थितियों का इलाज करते हैं</h3>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅ टूटा हुआ दांत </li>
                                    <li>  ✅ सेंसिटिविटी </li>
                                    <li>  ✅ हाइपरडोंटिया</li>
                                    <li>  ✅ मसूड़े और दांतों से जुड़ी दूसरी समस्याएं</li>
                                    <li>  ✅ दांत दर्द</li>
                                    <li>  ✅ दागदार दांत </li>
                                    <li>  ✅ टूटा हुआ दांत</li>
                                    <li>  ✅ दबा हुआ दांत</li>
                                </ul>


                                <h3>दांतों की सेवाओं के प्रकार</h3>
                                <b style={{ color: "black" }}>1. प्रिवेंटिव डेंटिस्ट्री (बुनियादी देखभाल)</b>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅ नियमित डेंटल चेक-अप</li>
                                    <li>  ✅ दांतों की सफाई और पॉलिशिंग</li>
                                    <li>  ✅ फ्लोराइड ट्रीटमेंट</li>
                                    <li>  ✅ डेंटल एक्स-रे</li>
                                    <li>  ✅ सीलेंट्स</li>
                                </ul>
                                <b style={{ color: "black" }}>2. रेस्टोरेटिव डेंटिस्ट्री (इलाज संबंधी देखभाल)</b>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅ दांतों की फिलिंग</li>
                                    <li>  ✅ डेंटल क्राउन और ब्रिज</li>
                                    <li>  ✅ रूट कैनाल ट्रीटमेंट (RCT)</li>
                                    <li>  ✅ दांत निकालना</li>
                                </ul>
                                <b style={{ color: "black" }}>3. कॉस्मेटिक डेंटिस्ट्री (मुस्कान में सुधार)</b>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅ दांतों को सफेद करना (टीथ व्हाइटनिंग)</li>
                                    <li>  ✅ स्माइल डिजाइनिंग</li>
                                    <li>  ✅ डेंटल बॉन्डिंग</li>
                                </ul>
                                <b style={{ color: "black" }}>4. ऑर्थोडॉन्टिक ट्रीटमेंट (सीध में लाना)</b>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅ ब्रेसेस</li>
                                    <li>  ✅ क्लियर अलाइनर्स</li>
                                    <li>  ✅ रिटेनर्स</li>
                                </ul>
                                <b style={{ color: "black" }}>5. सर्जिकल और एडवांस्ड प्रक्रियाएं</b>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅ अक्ल दाढ़ निकालना</li>
                                    <li>  ✅ डेंटल इम्प्लांट्स</li>
                                    <li>  ✅ ओरल सर्जरी</li>
                                    <li>  ✅ मसूड़ों की सर्जरी</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 m-b30">
                            <aside className="side-bar sticky-top left">
                                <div className="widget service_menu_nav bg-secondary wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                    <div className="widget-title">
                                        <h4 className="title">सभी सेवाएँ</h4>
                                    </div>
                                    <ul>
                                        <li className="active"><Link to="/dental">डेंटल</Link></li>
                                        <li><Link to="/general-medicine">सामान्य दवा</Link></li>
                                        <li><Link to="/general-surgery">जनरल सर्जरी</Link></li>
                                        <li><Link to="/orthopedic">ऑर्थोपेडिक</Link></li>
                                        <li><Link to="/physiotherapy">फिजियोथेरेपी</Link></li>
                                        <li ><Link to="/urology">यूरोलॉजी</Link></li>
                                        <li ><Link to="/dermatology">डर्मेटोलॉजी</Link></li>
                                        <li ><Link to="/pulmonology">पल्मोनोलॉजी</Link></li>
                                        <li><Link to="/ent">कान, नाक और गले</Link></li>
                                        <li><Link to="/anaesthesiology">एनेस्थिसियोलॉजी</Link></li>
                                        <li><Link to="/general-medicine">जनरल मेडिसिन</Link></li>
                                        <li><Link to="/gynaecology">ऑब्सटेट्रिक्स और गायनेकोलॉजी</Link></li>
                                        <li><Link to="/paediatrics">पीडियाट्रिक्स</Link></li>
                                    </ul>
                                </div>
                                <div className="widget_contact" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)' }} data-wow-delay="0.4s" data-wow-duration="0.7s">
                                    <div className="widget-content">
                                        <img src="./assets/images/question.png" width={80} alt />
                                        <h4 className="title">क्या आपको किसी मदद की ज़रूरत है?</h4>
                                        <div className="phone-number">
                                            <a href="tel:+919165155945">+91 9165155945</a>
                                        </div>
                                        <div className="email">
                                            <a href="mailto:omkarmultispecialityhospital1@gmail.com">omkarmultispecialityhospital1
                                                @gmail.com</a>
                                        </div>
                                        <div className="link-btn">
                                            <a to="/contact-us" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                                                Contact Us <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Dental